// Square.js

import { memo, useContext, useRef } from 'react';
import useInteract from '../utils/useInteract';
import { getNodeIcon } from '../utils/nodeIcons';
import { CurrentHitContext } from './App'; // Import the context

const Square = memo(
  ({
    id,
    color,
    colorKey,
    position,
    rotation,
    onDrag,
    onRotate,
    onRightClick,
    onSelect,
    soundBank,
  }) => {
    const { currentHit } = useContext(CurrentHitContext);
    const ref = useRef(null);
    const rotateHandleRef = useRef(null);
    useInteract(
      ref,
      rotateHandleRef,
      position,
      rotation,
      newPos => onDrag(id, newPos),
      newRotation => onRotate(id, newRotation)
    );

    const handleClick = () => {
      if (onSelect) {
        onSelect({ id, layer: 1 });
      }
    };

    const handleContextMenu = event => {
      event.preventDefault();
      onRightClick(id);
    };

    const nodeIcon = getNodeIcon(colorKey, soundBank);

    // Image style
    const imageStyle = {
      width: '40px',
      height: 'auto', // Maintain aspect ratio
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };

    const squareStyle = {
      width: '80px',
      height: '80px',
      backgroundColor: color,
      position: 'absolute',
      left: `${position.x}px`,
      top: `${position.y}px`,
      transform: `rotate(${rotation}deg) translateZ(0)`, // Apply rotation and trigger hardware acceleration
      lineHeight: '80px',
      textAlign: 'center',
      color: 'white',
      fontWeight: 'bold',
      cursor: 'move',
      border: currentHit === id ? '2px solid white' : '2px solid #737373',
      boxShadow: `0px 0px 10px 0px #737373`,
      zIndex: 3, // High z-index,
    };

    const rotateHandleStyle = {
      position: 'absolute',
      bottom: '0',
      right: '0',
      width: '20px',
      height: '20px',
      backgroundColor: '#383838',
      cursor: 'pointer',
    };

    return (
      <div
        ref={ref}
        style={squareStyle}
        onContextMenu={handleContextMenu}
        onClick={handleClick}
      >
        {nodeIcon && (
          <img
            src={nodeIcon}
            style={imageStyle}
            alt="Square Icon"
          />
        )}
        <div ref={rotateHandleRef} style={rotateHandleStyle} />
      </div>
    );
  }
);

export default Square;
